import { PaymentMethodType } from "../../../../modules/payments/paymentTypes"

import type { DeliveryTimesField, PaymentMethodOption } from "../components/form/formTypes"
import { MeetingServicePriceListStatus } from "../createOrderTypes"

export const defaultMultipleDeliveries: DeliveryTimesField = { deliveryDate: null, deliveryTimes: [], activeTime: null }

export const defaultPriceList = { item: null, status: MeetingServicePriceListStatus.UNSELECTED }

export const defaultPaymentMethod: PaymentMethodOption = {
    value: PaymentMethodType.INVOICE,
    icon: { type: "FONT_AWESOME", spec: "fa-light fa-file-lines" },
}
